function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["count"];
var _templateObject;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
// @ts-nocheck
import React, { useState, useContext } from 'react';
import { useIntl } from 'react-intl';
import { decamelize } from 'humps';
import { Button, Input, Popover, Spin } from 'antd';
import { css } from '@emotion/css';
import { NtqToolbarContext } from "../NtqToolbar/NtqToolbarProvider";
var url = '/ntq_tools';
var defaultOptions = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json;charset=UTF-8'
  }
};
var linkCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-style: italic;\n  color: #4527a0;\n  text-decoration-line: underline;\n  text-decoration-style: dashed;\n  &:hover {\n    color: #4527a0;\n  }\n"])));
var MissingTranslationItem = function MissingTranslationItem(props) {
  var translationKey = props.translationKey,
    preventDefault = props.preventDefault;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(props.value),
    _useState4 = _slicedToArray(_useState3, 2),
    value = _useState4[0],
    setValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var onSubmit = function onSubmit() {
    fetch("".concat(url, "/translation"), _objectSpread(_objectSpread({}, defaultOptions), {}, {
      method: 'PUT',
      body: JSON.stringify({
        key: translationKey,
        value: value
      })
    })).then(function (response) {
      return response.json();
    }).then(function (_ref) {
      var data = _ref.data;
      if (data) {
        setOpen(false);
      }
    });
  };
  var content = open ? /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 150,
      minHeight: 75
    }
  }, loading ? /*#__PURE__*/React.createElement("div", {
    style: {
      height: 75,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Spin, null)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input.TextArea, {
    value: value,
    onChange: function onChange(_ref2) {
      var value = _ref2.target.value;
      return setValue(value);
    },
    autoSize: true
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onSubmit,
    size: "small",
    type: "primary"
  }, "Modifier")))) : null;
  var onOpenChange = function onOpenChange(visible) {
    setOpen(visible);
    setLoading(true);
    fetch("".concat(url, "/translation?key=").concat(translationKey), defaultOptions).then(function (response) {
      return response.json();
    }).then(function (_ref3) {
      var data = _ref3.data;
      setValue(data);
      setLoading(false);
    });
  };
  var onClick = function onClick(e) {
    if (preventDefault) e.stopPropagation();
  };
  return /*#__PURE__*/React.createElement(Popover, {
    title: loading ? null : translationKey,
    content: content,
    open: open,
    trigger: 'click',
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement("a", {
    onClick: onClick,
    className: linkCss
  }, props.value || translationKey));
};
var useI18n = function useI18n(opts) {
  var _ref4 = opts || {},
    _ref4$debug = _ref4.debug,
    debug = _ref4$debug === void 0 ? false : _ref4$debug;
  var toolbarConfig = useContext(NtqToolbarContext);
  var intl = useIntl();
  var isTranslated = function isTranslated(key) {
    return intl.formatMessage({
      id: key
    }) !== key;
  };
  var t = function t(key) {
    var _toolbarConfig$i18n;
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var count = args.count,
      rest = _objectWithoutProperties(args, _excluded);
    var k = key;
    if (args && args.count !== undefined) {
      var pluralKey = 'zero';
      if (args.count > 1) pluralKey = 'other';else if (args.count === 1) pluralKey = 'one';
      k = "".concat(key, ".").concat(pluralKey);
    }
    k = decamelize(k);
    var translation = intl.formatMessage({
      id: k
    }, args);
    if (debug || toolbarConfig !== null && toolbarConfig !== void 0 && (_toolbarConfig$i18n = toolbarConfig.i18n) !== null && _toolbarConfig$i18n !== void 0 && _toolbarConfig$i18n.debug) {
      var _toolbarConfig$i18n2;
      return /*#__PURE__*/React.createElement(MissingTranslationItem, {
        translationKey: k,
        value: translation,
        preventDefault: toolbarConfig === null || toolbarConfig === void 0 ? void 0 : (_toolbarConfig$i18n2 = toolbarConfig.i18n) === null || _toolbarConfig$i18n2 === void 0 ? void 0 : _toolbarConfig$i18n2.preventDefault
      });
    }
    return translation;
  };
  var tAttribute = function tAttribute(modelName, attributeName) {
    return t("activerecord.attributes.".concat(decamelize(modelName), ".").concat(decamelize(attributeName)));
  };
  return {
    t: t,
    translate: t,
    tAttribute: tAttribute,
    isTranslated: isTranslated
  };
};
export default useI18n;